import React, { useState, useEffect } from "react";
import { styled, createTheme } from "@mui/material/styles";
// import { makeStyles } from "@mui/material/styles";

import TablePagination from "@mui/material/TablePagination";
import SnackBars from "./SnackBar";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
  IconButton,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import Checkbox from "@mui/material/Checkbox";
import EditDelete from "./EditDelete";
import dayjs from "dayjs";
const theme = createTheme({});

const PaperStyled = styled(Paper)(() => ({
  width: "100%",
  textAlign: "center",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  overflowX: "auto",
  alignItems: "center",
  "& > *:not(:last-child)": {
    marginRight: theme.spacing(2),
  },
}));

// const useStyles = makeStyles((theme) => ({
//   editIcon: {
//     color: "#DADADA",
//     cursor: "pointer",
//     stroke: "#AAC1B0",
//     strokeWidth: 2,
//     backgroundColor: "#AAC1B0",
//     borderRadius: "50%",
//   },
//   tableRightBorder: {
//     borderWidth: 0,
//     borderWidth: "0.5px",
//     borderColor: "#acadad40",
//     borderStyle: "solid",
//   },
//   sticky: { position: "sticky", left: 0, background: "white", zIndex: 2000 },
// }));

export default function DesktopTable({
  headCells,
  tableResponse = [],
  totalCount,
  setOpenLocationSubModal = () => {},
  showMagicUrlGenerator = false,
  showPagination = true,
  rowsPerPage = 10,
  setOffset = () => {},
  setSortingType = () => {},
  sortingType,
  setSortBy = () => {},
  sortBy,
  setopenEditModal = () => {},
  setEditData = () => {},
  setOpenDeleteModal = () => {},
  setDeleteData = () => {},
  setPage = () => {},
  page = 0,
  setOpenListModal = () => {},
  setListData = () => {},
  setReload = () => {},
  canEdit = true,
  canDelete = true,
}) {
  // const classes = useStyles();
  const [showAllTranslations, setShowAllTranslations] =
    React.useState("see more");
  const [translationsToShow, setTranslationsToShow] = React.useState(2);
  const [permission, setPermission] = React.useState(tableResponse);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [showSnackBarMessage, setShowSnackBarMessage] = useState("");

  const handleShowAllTranslation = (lengthOfArray) => {
    if (translationsToShow === 2) {
      setTranslationsToShow(lengthOfArray);
      setShowAllTranslations("see less");
    } else {
      setTranslationsToShow(2);
      setShowAllTranslations("see more");
    }
  };

  function capitaliseFirstLetter(str) {
    if (!str || str === "" || str === null || str === undefined) {
      return str;
    }
    let words = str.split(" ");
    for (let i = 0; i < words.length; i++) {
      if (words[i] && words[i].length > 0) {
        words[i] = words[i][0].toUpperCase() + words[i].substring(1);
      }
    }
    let newStr = words.join(" ");
    return newStr;
  }

  useEffect(() => {
    if (totalCount === -1 || totalCount === 0) {
      setShowSnackBar(true);
      setShowSnackBarMessage("No Data Found! Try changing filters");
    } else {
      setShowSnackBar(false);
      setShowSnackBarMessage("");
    }
  }, [totalCount]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleSortRequest = (cellId) => {
    const shouldSortDesc = sortBy === cellId && sortingType === "asc";
    setSortingType(shouldSortDesc ? "desc" : "asc");
    // setPage(0);
    setSortBy(cellId);
  };

  useEffect(() => {
    setOffset(page * rowsPerPage);
  }, [page]);

  return (
    <PaperStyled
      sx={{
        marginLeft: 10,
        marginRight: 5,
        width: "auto",
        borderRadius: "12px",
      }}
    >
      {totalCount !== -1 && (
        <Grid item xs={12}>
          <TableContainer
            sx={{ maxHeight: "750px", minWidth: 100, borderRadius: "12px" }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow
                  sx={{
                    "& th": { backgroundColor: "#e3f2fd" },
                    textAlign: "center",
                    width: "2000px",
                  }}
                >
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.key}
                      style={
                        headCell.sticky === true
                          ? {
                            position: "sticky",
                            left: 0,
                            zIndex: 1000,
                            borderRight: "1px solid #E6E6E6",
                            top: 0,
                          }
                          : { width: "1000px" }
                      }
                      sx={{
                        fontFamily: "Inter",
                        fontStyle: "normal",
                        color: "#5E6060",
                        fontWeight: 500,
                        fontSize: "18px",
                        lineHeight: "22px",
                      }}
                    // className={classes.tableRightBorder}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {headCell.sort ? (
                          <TableSortLabel
                            onClick={() => {
                              handleSortRequest(headCell.key);
                            }}
                            direction={
                              sortBy === headCell.key ? sortingType : "asc"
                            }
                            active={sortBy === headCell.key}
                          >
                            {headCell.label}
                          </TableSortLabel>
                        ) : (
                          headCell.label
                        )}
                        {headCell.key === "is_translated" && (
                          <IconButton onClick={() => setReload(true)}>
                            <RefreshIcon />
                          </IconButton>
                        )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableResponse.map((row, index) => {
                  const disable = row.hasOwnProperty("is_translated")
                    ? !row.is_translated
                    : false;
                  return (
                    <TableRow hover role="checkbox" key={index}>
                      {headCells.map((headCell) => {
                        return (
                          <TableCell
                            width={
                              headCell.type === "editDelete" ? "1%" : "12%"
                            }
                            style={
                              headCell.sticky === true
                                ? {
                                  position: "sticky",
                                  left: 0,
                                  background: "white",
                                  zIndex: 800,
                                  top: 0,
                                }
                                : {}
                            }
                            key={headCell.key}
                            sx={{
                              fontSize: "18px",
                              fontFamily: "Inter",
                              color: "#5E6060",
                              fontWeight: 400,
                              padding: "10px",
                            }}
                          // className={classes.tableRightBorder}
                          >
                            {(headCell.type === "question" ||
                              headCell.type === "forms") &&
                              row[headCell.key] !== null &&
                              row[headCell.key] !== undefined &&
                              row[headCell.key].length > 0 ? (
                              <p
                                style={{
                                  color: disable ? "#AAAAAA" : "#52B788",
                                  cursor: !disable && "pointer",
                                }}
                              >
                                <span
                                  onClick={() => {
                                    if (!disable) {
                                      setOpenListModal(true);
                                      setListData(row[headCell.key]);
                                    }
                                  }}
                                >
                                  {headCell.type === "question"
                                    ? `Questions(${row[headCell.key].length})`
                                    : `Forms(${row[headCell.key].length})`}
                                </span>
                              </p>
                            ) : headCell.type === "projects" &&
                              row[headCell.key] !== null &&
                              row[headCell.key] !== undefined &&
                              row[headCell.key].length > 0 ? (
                              <p>Projects({row[headCell.key].length})</p>
                            ) : headCell.type === "date" ? (
                              <p>
                                {row[headCell.key] === undefined
                                  ? row[headCell.key]
                                  : dayjs(row[headCell.key]).format(
                                    "D MMMM, YYYY"
                                  )}
                              </p>
                            ) : headCell.type === "checkbox" ? (
                              <Checkbox
                                disabled
                                checked={row[headCell.key] ? true : false}
                                sx={{
                                  color: "#2D6A4F",
                                  "&.Mui-checked": { color: "#2D6A4F" },
                                }}
                              />
                            ) : headCell.type === "editDelete" ? (
                              <EditDelete
                                setopenEditModal={setopenEditModal}
                                setOpenDeleteModal={setOpenDeleteModal}
                                data={row}
                                canEdit={canEdit}
                                canDelete={canDelete}
                                showMagicUrlGenerator={showMagicUrlGenerator}
                                setEditData={setEditData}
                                setDeleteData={setDeleteData}
                                disabled={disable}
                              />
                            ) : headCell.type === "location" ? (
                              row[headCell.key] !== null &&
                              row[headCell.key] !== undefined &&
                              row[headCell.key].length > 0 &&
                              row[headCell.key].map((state_wise, index) => {
                                return (
                                  <p key={index}>
                                    {state_wise.state.name}{" "}
                                    <span
                                      onClick={() => {
                                        setOpenLocationSubModal(true);
                                        setEditData(row);
                                      }}
                                      style={{
                                        color: "#52B788",
                                        cursor: "pointer",
                                      }}
                                    >
                                      ( {state_wise.locations.length} )
                                    </span>
                                  </p>
                                );
                              })
                            ) : headCell.type === "array_objects" ? (
                              row["role"] !== "Government" &&
                              row[headCell.key].data.length > 0 &&
                              row[headCell.key].data.map((arr, index) => {
                                return <p key={index}>{arr.name}</p>;
                              })
                            ) : headCell.type === "pesticide" ? (
                              <p>
                                <span>{row.code}</span>
                                <br />
                                <span>{row.title}</span>
                              </p>
                            ) : headCell.type === "partnerPesticide" ? (
                              row.pesticides.map((list_data, ind) => {
                                return <p key={ind}>{list_data} </p>;
                              })
                            ) : headCell.type === "location" ? (
                              row[headCell.key].length > 0 &&
                              row[headCell.key].map((state_wise, index) => {
                                return (
                                  <p key={index}>
                                    {state_wise.state.name}{" "}
                                    <span
                                      onClick={() => {
                                        setOpenLocationSubModal(true);
                                        setEditData(row);
                                      }}
                                      style={{
                                        color: "#52B788",
                                        cursor: "pointer",
                                      }}
                                    >
                                      ( {state_wise.locations.length} )
                                    </span>
                                  </p>
                                );
                              })
                            ) : headCell.type === "user" ? (
                              <p>
                                <span>
                                  {row[headCell.key] && row[headCell.key].name
                                    ? capitaliseFirstLetter(row[headCell.key].name)
                                    : "Not Available"}
                                </span>
                                <br />
                                <span>{row[headCell.key] && row[headCell.key].email ? row[headCell.key].email : "Not Available"}</span>
                                <br />
                                <span>{row[headCell.key] && row[headCell.key].phone_number ? row[headCell.key].phone_number : "Not Available"}</span>
                              </p>
                            ) : headCell.type === "name_number" ? (
                              <p>
                                <span>
                                  {row[headCell.key] && row[headCell.key].name
                                    ? capitaliseFirstLetter(row[headCell.key].name)
                                    : "Not Available"}
                                </span>
                                <br />
                                <span>{row[headCell.key] && row[headCell.key].phone_number ? row[headCell.key].phone_number : "Not Available"}</span>
                              </p>
                            ) : headCell.type === "name_number_location" ? (
                              <p>
                                <span>{row.name ? capitaliseFirstLetter(row.name) : "Not Available"}</span>
                                &nbsp;
                                <br />
                                <span>{row.phone_number ? row.phone_number : "Not Available"}</span>&nbsp;
                                <br />
                                <span>{row.location_name ? row.location_name : "Not Available"}</span>
                              </p>
                            ) : headCell.type === "boolean" ? (
                              row[headCell.key] == true ? (
                                <p
                                  style={{
                                    color: disable ? "#AAAAAA" : "#2D6A4F",
                                  }}
                                >
                                  Active
                                </p>
                              ) : row[headCell.key] == false ? (
                                <p
                                  style={{
                                    color: disable ? "#AAAAAA" : "#EB5451",
                                  }}
                                >
                                  Inactive
                                </p>
                              ) : (
                                ""
                              )
                            ) : headCell.type === "translated_status" ? (
                              row[headCell.key] == true ? (
                                <p style={{ color: "#2D6A4F" }}>Completed</p>
                              ) : row[headCell.key] == false ||
                                row[headCell.key] == null ? (
                                <p style={{ color: "#EB5451" }}>Pending</p>
                              ) : (
                                ""
                              )
                            ) : row[headCell.key] && row[headCell.key].id ? (
                              headCell.capital ? (
                                <p style={{ color: disable && "#AAAAAA" }}>
                                  {row[headCell.key].name
                                    ? capitaliseFirstLetter(row[headCell.key].name)
                                    : "Not Available"}
                                </p>
                              ) : (
                                <p style={{ color: disable && "#AAAAAA" }}>
                                  {" "}
                                  {row[headCell.key].name ? row[headCell.key].name : "Not Available"}{" "}
                                </p>
                              )
                            ) : (
                              <p>
                                {headCell.capital
                                  ? (row[headCell.key] ? capitaliseFirstLetter(row[headCell.key]) : "Not Available")
                                  : row[headCell.key] === null
                                    ? "Not Available"
                                    : row[headCell.key]}
                              </p>
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          {showPagination && (
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              sx={{ display: "flex", justifyContent: "center" }}
            />
          )}
        </Grid>
      )}
      {showSnackBar && (
        <SnackBars
          open={showSnackBar}
          handleClose={() => setShowSnackBar(false)}
          severity="error"
          message={showSnackBarMessage}
          autoHideDuration={6000}
          vertical="bottom"
          horizontal="center"
        />
      )}
    </PaperStyled>
  );
}
